var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_vm._t("default",null,{"isCollapsed":_vm.isCollapsed,"toggleCollapse":_vm.toggleCollapse})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }